export { SuiDropdownModule, DropdownAutoCloseType } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/dropdown/public.js
// module id = 1106
// module chunks = 0